export default __webpack_public_path__ + "static/media/FAC5.e05d45d7.jpg";